/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CreateOrUpdateLCPage = lazyLoad(
  () => import('./index'),
  module => module.CreateOrUpdateLCPage,
);
